import React, { useState, useRef, useCallback } from 'react';
import { Typography, Button, MenuItem, Link } from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useAppState } from '../../../state';
import UserAvatar from './UserAvatar/UserAvatar';
import Menu from '@mui/material/Menu';
import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';

const UserContainer = styled('div')({
  position: 'absolute',
  top: 0,
  right: 0,
  margin: '1em',
  display: 'flex',
  alignItems: 'center',
});

const UserButton = styled(Button)({
  color: 'white',
});

const LogoutLink = styled(Link)({
  color: 'white',
  cursor: 'pointer',
  padding: '0px 20px',
});

const UserMenu: React.FC = () => {
  const { user, signOut } = useAppState();
  const { localTracks } = useVideoContext();

  const [menuOpen, setMenuOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleSignOut = useCallback(() => {
    localTracks.forEach(track => track.stop());
    signOut?.();
  }, [localTracks, signOut]);

  if (true) {
    return (
      <UserContainer>
        <LogoutLink onClick={handleSignOut}>
          Logout
        </LogoutLink>
      </UserContainer>
    );
  }

  // if (process.env.REACT_APP_SET_AUTH === 'firebase') {
  //   return (
  //     <UserContainer>
  //       <UserAvatar user={user} />
  //       <UserButton onClick={() => setMenuOpen(isOpen => !isOpen)} ref={anchorRef}>
  //         {user!.displayName}
  //         <ExpandMoreIcon />
  //       </UserButton>
  //       <Menu
  //         open={menuOpen}
  //         onClose={() => setMenuOpen(isOpen => !isOpen)}
  //         anchorEl={anchorRef.current}
  //         getContentAnchorEl={null}
  //         anchorOrigin={{
  //           vertical: 'bottom',
  //           horizontal: 'center',
  //         }}
  //         transformOrigin={{
  //           vertical: 'top',
  //           horizontal: 'center',
  //         }}
  //       >
  //         <MenuItem onClick={handleSignOut}>
  //           <Typography variant="body1">Logout</Typography>
  //         </MenuItem>
  //       </Menu>
  //     </UserContainer>
  //   );
  // }

  return null;
};

export default UserMenu;
